import {
  UWPNotifier,
  OutputAction
} from './UWPNotifier'

export const triggerPlayback = (titleId: string, downloadId: string) => {
  UWPNotifier.getInstance().publish(OutputAction.Download_Play, { titleId, downloadId })
}